module.exports = __webpack_public_path__ + "img/algo.19b0bb02.svg";